var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotKeys({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107,
    height: 111,
    viewBox: "0 0 107 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1595",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1596",
    x: 37,
    y: 41,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1546",
    "data-name": "Group 1546",
    transform: "translate(-729 -388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1545",
    "data-name": "Group 1545",
    transform: "translate(734 396)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5, -8)",
    filter: "url(#Rectangle_1595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1595-2",
    "data-name": "Rectangle 1595",
    transform: "translate(5 8)",
    fill: "#fff",
    stroke: "#cecece",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Ctrl",
    transform: "translate(7 33)",
    fill: "#707070",
    fontSize: 21,
    fontFamily: "Inter-Regular, Inter"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ctrl"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1544",
    "data-name": "Group 1544",
    transform: "translate(771.284 437.284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -42.28, -49.28)",
    filter: "url(#Rectangle_1596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1596-2",
    "data-name": "Rectangle 1596",
    transform: "translate(42 49)",
    fill: "#fff",
    stroke: "#cecece",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 4.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1543",
    "data-name": "Group 1543",
    transform: "translate(12.027 13.23)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "x",
    transform: "translate(11.663 21)",
    fill: "#707070",
    fontSize: 21,
    fontFamily: "Inter-Regular, Inter"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "x")), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M2095.3,430.457l6.491,3.967v-15.58h22.242",
    transform: "translate(-2095.303 -414.221)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotKeys);
export default __webpack_public_path__ + "static/media/hotKeys.94f539596aadc040ad197e474dc79599.svg";
export { ForwardRef as ReactComponent };